var exports = {
  "S": "xa15a2ab7--bef345--image",
};

module.exports = exports;
